.container {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
  padding: var(--hcr-spacing-4) 0;
}

.description {
  margin: 0;
  color: var(--hcr-content-secondary-color);
}

.rowList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-3);
}

.addButton {
  color: var(--hcr-button-primary-color);
}

.deleteCol {
  display: flex;
  align-items: flex-end;
  min-height: 100%;
}

.deleteButton:hover {
  color: var(--hcr-danger-color);
}

